<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      //GroupReveal(:groupProp="item", @refresh="$emit('refresh')")
      ActionButton(:action="remove") Delete

</template>

<script>
  import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'
  import GroupReveal from '../../../../pages/backoffice/GroupEdit'

  export default {
    name: 'DriverGroupButtons',
    components: {GroupReveal, PolicyReveal, ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.driverGroups.select(this.driver.id).detach({group_id: this.item.id}, () => {
          MaggieHelper.notification('', 'Policy deleted')
          this.$emit('refresh')
        })
      }
    },

    props: ['item', 'driver']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DriverGroupButtons.vue?e9fc3cfc